import { View } from "react-native";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import getGatheringUserTagSuggestions from "../_/helpers/getGatheringUserTagSuggestions";
import useGatheringCommentsThreadThemeFragment from "../_/hooks/useGatheringCommentsThreadThemeFragment";
import CommentsThread from "../CommentsThread";
import { usePhotoCommentsThreadDimensions } from "./PhotoCommentsThreadSkeleton";

const PhotoCommentsThread = () => {
	const style = usePhotoCommentsThreadDimensions();
	const { props, closeSelf } = useInsideModal<GatheringModal["PhotoCommentsThread"]>();
	const gatheringTheme = useGatheringCommentsThreadThemeFragment({
		gatheringId: props.gatheringId,
	});

	return (
		<View style={style}>
			<CommentsThread
				threadSpecifier={{
					gatheringId: props.gatheringId,
					photoId: props.photoId,
				}}
				displayMessageThreads={false}
				isAdmin={props.isAdmin}
				onClose={closeSelf}
				testID="PhotoThreadComments"
				getUserTagSuggestions={getGatheringUserTagSuggestions}
				{...gatheringTheme}
			/>
		</View>
	);
};
export default PhotoCommentsThread;
